import React from 'react';
import { useCreatePersonForm } from './CreatePersonForm';
import { Button, ButtonColor, ButtonSize, ButtonVariant, IconType, OptionSelectionButton } from 'ui-builder';
import { useBulkImportForm } from '../BulkImport/BulkImportForm';
import useFeatureToggleService from 'feature-toggle';

export default function CreateContactButton() {
  const form = useCreatePersonForm();
  const bulkImportForm = useBulkImportForm();
  const featureToggleService = useFeatureToggleService();

  const isBulkImportEnabled = featureToggleService.isBulkContactsImportEnabled();

  if (isBulkImportEnabled) {
    return (
      <OptionSelectionButton
        text="Add Contact"
        size={ButtonSize.MEDIUM}
        options={[
          {
            label: 'Single Contact',
            value: 'single',
            onSelected: () => form.open(),
          },
          {
            label: 'Import from CSV',
            value: 'bulk',
            onSelected: () => bulkImportForm.open(),
          },
        ]}
      />
    );
  } else {
    return (
      <Button
        text="Add Contact"
        onClick={() => form.open()}
        size={ButtonSize.MEDIUM}
        variant={ButtonVariant.FILLED}
        color={ButtonColor.BLUE}
        iconType={IconType.PLUS}
      />
    );
  }
}
